export default __webpack_public_path__ + "static/media/1st.88d1e469.png";